import {
  BankAccountInfiniteSelectField,
  InputDate,
} from '@/components/_common';
import DocumentTypesSelectField from '@/components/_common/DocumentTypesSelectField';
import { AccountReceivableInstallmentGroupingItem } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import formatterPrice from '@/utils/number/formatterPrice';
import { COLUMNS_WIDTH } from '@/utils/table';
import { Input, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';

import { FaExchangeAlt } from 'react-icons/fa';

type Props = {
  installments: AccountReceivableInstallmentGroupingItem[];
  setInstallments: React.Dispatch<
    React.SetStateAction<AccountReceivableInstallmentGroupingItem[]>
  >;
};

const AccountReceivableGroupingInstallmentList: React.FC<Props> = ({
  installments,
  setInstallments,
}) => {
  function setFieldValue([field, index]: [string, number], value: unknown) {
    setInstallments((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
    );
  }

  function setDocumentTypeId(documentTypeId: number) {
    setInstallments(installments.map((item) => ({ ...item, documentTypeId })));
  }

  function setBankAccountId(bankAccountId: number) {
    setInstallments(installments.map((item) => ({ ...item, bankAccountId })));
  }

  const columns: ColumnsType<AccountReceivableInstallmentGroupingItem> = [
    {
      dataIndex: 'description',
      title: 'Descrição',
      width: COLUMNS_WIDTH.default,
      render: (value: string, _, i) => (
        <Input
          value={value}
          onChange={({ target }) =>
            setFieldValue(['description', i], target.value)
          }
        />
      ),
    },
    {
      dataIndex: 'documentNumber',
      title: 'Número do documento',
      width: COLUMNS_WIDTH.default,
      render: (value: string, _, i) => (
        <Input
          value={value}
          onChange={({ target }) =>
            setFieldValue(['documentNumber', i], target.value)
          }
        />
      ),
    },
    {
      dataIndex: 'documentTypeId',
      title: 'Tipo de documento',
      width: COLUMNS_WIDTH.default,
      filterDropdown: () => {
        return (
          <DocumentTypesSelectField
            style={{ width: 200, minWidth: COLUMNS_WIDTH.default }}
            onChange={setDocumentTypeId}
          />
        );
      },
      filterIcon: <FaExchangeAlt size={14} />,
      render: (value: string, _, i) => (
        <DocumentTypesSelectField
          value={value}
          onChange={(targetValue) =>
            setFieldValue(['documentTypeId', i], targetValue)
          }
          style={{
            border: installments.every(
              (installment) => !installment.documentTypeId,
            )
              ? '1px solid red'
              : undefined,
            width: '100%',
          }}
        />
      ),
    },
    {
      dataIndex: 'bankAccountId',
      title: 'Conta bancária',
      width: COLUMNS_WIDTH.default,
      filterDropdown: () => {
        return (
          <BankAccountInfiniteSelectField
            queryFilter={{ active: true }}
            allowClear
            style={{ width: 200, minWidth: COLUMNS_WIDTH.default }}
            onChange={setBankAccountId}
          />
        );
      },
      filterIcon: <FaExchangeAlt size={14} />,
      render: (value: string, _, i) => (
        <BankAccountInfiniteSelectField
          queryFilter={{ active: true }}
          allowClear
          value={value}
          onChange={(targetValue) =>
            setFieldValue(['bankAccountId', i], targetValue)
          }
          style={{
            border: installments.every(
              (installment) => !installment.bankAccountId,
            )
              ? '1px solid red'
              : undefined,
            width: '100%',
          }}
        />
      ),
    },
    {
      align: 'right',
      dataIndex: 'dueDate',
      title: 'Vencimento',
      width: COLUMNS_WIDTH.date,
      render: (value: string, _, i) => (
        <InputDate
          value={moment(value)}
          onChange={(targetValue) => setFieldValue(['dueDate', i], targetValue)}
        />
      ),
    },
    {
      align: 'right',
      dataIndex: 'installmentValue',
      title: 'Valor da parcela',
      width: COLUMNS_WIDTH.price,
      render: (value: number) => formatterPrice(value),
    },
  ];

  return (
    <>
      <Typography.Title style={{ marginTop: 24 }} level={4}>
        Novas parcelas
      </Typography.Title>
      <Table dataSource={installments} columns={columns} pagination={false} />
    </>
  );
};

export default AccountReceivableGroupingInstallmentList;
